import React, {useRef, useState} from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, {textFilter, numberFilter, Comparator, dateFilter} from 'react-bootstrap-table2-filter';
import ToolkitProvider, {
    CSVExport,
    ColumnToggle
} from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import paginationFactory, {
    PaginationProvider,
    PaginationTotalStandalone,
    PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import {Button} from "react-bootstrap";
import Moment from "moment";
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

const MyExportCSV = (props) => {
    const handleClick = () => {
        props.onExport();
    };
    return (
        <button className="btn btn-success" onClick={handleClick}>
            Export Visible Data
        </button>
    );
};

const {ToggleList} = ColumnToggle;
const columns = [{
    dataField: 'ordinal',
    text: '#',
    sort: true
}, {
    dataField: 'uid',
    text: 'Uid',
    filter: textFilter()
}, {
    dataField: 'name',
    text: 'Name',
    sort: true,
    filter: textFilter()
}, {
    dataField: 'gender',
    text: 'Gender'
}, {
    dataField: 'birthday',
    text: 'Birthday'
}, {
    dataField: 'value',
    text: 'Value',
    sort: true,
    filter: numberFilter({
        defaultValue: {number: 0, comparator: Comparator.GT}
    })
}, {
    dataField: 'visitsCount',
    text: '# Visits',
    sort: true,
    filter: numberFilter({
        defaultValue: {number: 0, comparator: Comparator.GT}
    })
}, {
    dataField: 'bonusCount',
    text: '# Bonus',
    sort: true,
    filter: numberFilter({
        defaultValue: {number: 0, comparator: Comparator.GT}
    })
}, {
    dataField: 'listOfCities',
    text: 'List of Cities',
    filter: textFilter(),
    style: {
        whiteSpace: 'pre-wrap',
        wordBreak: 'normal',
        maxWidth: '150px'
    },
    formatter: listFormatter
}, {
    dataField: 'cityList',
    text: 'City (Profile)',
    filter: textFilter(),
    style: {
        whiteSpace: 'pre-wrap',
        wordBreak: 'normal',
        maxWidth: '150px'
    },
    formatter: listFormatter
}, {
    dataField: 'listOfCompanies',
    hidden: true,
    text: 'List of Companies',
    filter: textFilter()
}, {
    dataField: 'listOfStoresId',
    text: 'List of Stores Id',
    filter: textFilter(),
    style: {
        whiteSpace: 'pre-wrap',
        wordBreak: 'normal',
        maxWidth: '200px'
    },
    formatter: listFormatter
}, {
    dataField: 'date',
    text: 'Date'
}, {
    dataField: 'time',
    text: 'Time'
}, {
    dataField: 'lastVisit',
    text: 'Last Visit',
    filter: dateFilter(),
    formatter: dateFormatter,
    csvFormatter: dateFormatter,
    hidden: false,
    sort: true
}, {
    dataField: 'lastSeen',
    text: 'Last Seen',
    filter: dateFilter(),
    formatter: dateFormatter,
    csvFormatter: dateFormatter,
    hidden: false,
    sort: true
}];

function dateFormatter(cell, row) {
    return Moment.tz(cell, 'Europe/Belgrade').format('DD.MM.YYYY');
}

function listFormatter(cell, row) {
    if (!cell) return '';
    // Split by comma and join with line breaks
    const items = cell.split(',').map(item => item.trim()).filter(item => item);
    return items.join('\n');
}

var data = [];

export const Visits = ({visits, handleNewCampaignListUid, company, exportRawButton, fetchVisitsByUids}) => {
    data = [];
    let bootstrapTableContainer = useRef(null)
    const [uidSearchInput, setUidSearchInput] = useState('');
    const [isSearching, setIsSearching] = useState(false);

    const rowEvents = {
        onClick: (e, row, rowIndex) => {
            // alert("Row index: " + (rowIndex + 1));
        }
    };

    const rowStyle = (scan) => {
    };

    const handleUidSearch = async () => {
        if (!uidSearchInput.trim()) return;

        // Parse comma-separated UIDs, trim whitespace
        const uids = uidSearchInput.split(',')
            .map(uid => uid.trim())
            .filter(uid => uid.length > 0);

        if (uids.length === 0) return;

        setIsSearching(true);
        try {
            await fetchVisitsByUids(uids);
        } finally {
            setIsSearching(false);
        }
    };

    visits.map((visit, index) => {
        data.push({
            ordinal: index + 1,
            uid: visit.uid,
            name: visit.firstName,
            gender: visit.gender,
            birthday: visit.birthday,
            value: visit.value,
            visitsCount: visit.count,
            bonusCount: visit.periodFilled,
            listOfCities: visit.listOfCities,
            listOfCompanies: visit.listOfCompanyCodes,
            listOfStoresId: visit.listOfStoresId,
            cityList: visit.cityList,
            date: visit.date,
            time: visit.time,
            lastVisit: visit.timestamp,
            lastSeen: visit.lastSeen?.toDate ? visit.lastSeen.toDate() : (visit.lastSeen || new Date(0)),
            period: visit.period
        });
    });

    const options = {
        sizePerPageList: [{text: '50', value: 50}, {text: '100', value: 100}, {text: '250', value: 250}, {
            text: 'All',
            value: data.length
        }],
        showTotal: true
    }

    const handleNewCampaign = () => {
        const currentTableData = bootstrapTableContainer.filterContext.data;
        if (!currentTableData.length) {
            return;
        }
        const listOfFilteredUidFromTable = currentTableData.map(row => row.uid);
        handleNewCampaignListUid(listOfFilteredUidFromTable);
    };

    return (
        <ToolkitProvider
            keyField='uid'
            data={data}
            columns={columns}
            columnToggle
            pagination={paginationFactory(options)}
            exportCSV={{
                exportAll: false,
                onlyExportFiltered: true
            }}>
            {props => (
                <div className="table-card">
                    {/* UID Search Section */}
                    <div className="p-4 mb-4 bg-gray-100 rounded-lg border border-gray-200">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Pretrazi po UID-ovima (razdvojeni zarezom):
                        </label>
                        <div className="flex flex-wrap items-center gap-3">
                            <input
                                type="text"
                                className="flex-1 min-w-64 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="uid1, uid2, uid3..."
                                value={uidSearchInput}
                                onChange={(e) => setUidSearchInput(e.target.value)}
                                onKeyPress={(e) => e.key === 'Enter' && handleUidSearch()}
                            />
                            <Button
                                variant="outline-primary"
                                onClick={handleUidSearch}
                                disabled={isSearching || !uidSearchInput.trim()}
                            >
                                {isSearching ? 'Trazim...' : 'Pretrazi'}
                            </Button>
                        </div>
                    </div>

                    {/* Table Actions */}
                    <div className="table-actions">
                        <div className="flex flex-wrap items-center gap-3">
                            <MyExportCSV {...props.csvProps}/>
                            {exportRawButton}
                            <Button variant="primary" onClick={handleNewCampaign}>
                                New Campaign For Visible Data
                            </Button>
                        </div>
                    </div>

                    {/* Column Toggle */}
                    <div className="column-toggle-section">
                        <p className="column-toggle-label">Show/Hide Columns:</p>
                        <ToggleList {...props.columnToggleProps} />
                    </div>

                    {/* Table */}
                    <div className="table-responsive">
                        <BootstrapTable striped bordered hover {...props.baseProps}
                                        ref={node => bootstrapTableContainer = node}
                                        pagination={paginationFactory(options)}
                                        rowStyle={rowStyle}
                                        rowEvents={rowEvents}
                                        bootstrap4={true}
                                        tabIndexCell
                                        filter={filterFactory()}
                        />
                    </div>
                </div>
            )
            }
        </ToolkitProvider>
    )
}
